import * as React from 'react';
import { connect } from 'react-redux';
import { DONATE_MY_DECREASE, PERSONAL_INSURANCE, REQUEST_DOCUMENTS, WHATSAPP_LIVE_CHAT } from '../../routes/routes';
import './WhatsNew.css';
import { showCallMeModal } from '../../actions/modalActions';
import { navigateTo } from '../../actions/navigationActions';

class WhatsNew extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            render: true,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleQuote = this.handleQuote.bind(this);
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize)
    }

    handleResize() {
        this.setState({ render: !this.state.render })
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleQuote() {
        if (this.props.profile.isLinked) {
            this.props.handleCallMeBack();
        }
        else {
            if (this.props.profile.countryId === 157) {
                this.props.handleCallMeBack();
            }
            else {
                window.open("https://kingprice.co.za/Home/QuoteIndex", '_blank');
            }
        }
    }

    public render() {
        const { profile } = this.props;

        let SAView = <>
            <div className="ssp-grid-dashboard-card-holder dashcard-ani-on">
                <div className="WhatsApp ssp-grid-dashboard-card" onClick={() => window.open(WHATSAPP_LIVE_CHAT, "_blank")}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>WhatsApp live chat</h2>
                                <p>Try it now</p>
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>

                <div className="TyreAndRim ssp-grid-dashboard-card" onClick={this.handleQuote}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>
                                    Tyre&nbsp;
                                    <span>and rim&nbsp;</span>
                                    insurance
                                </h2>
                                <p>Get a quote</p> 
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>

                <div className="ViewPolicy ssp-grid-dashboard-card" onClick={() => this.handleRedirect(REQUEST_DOCUMENTS)}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>Request a document</h2>
                                <p>See your latest schedule</p>
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>

                <div className="ScratchAndDent ssp-grid-dashboard-card" onClick={this.handleQuote}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>Scratch and dent</h2>
                                <p>Get a quote</p>
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>

        let NamView = <>
            <div className="ssp-grid-dashboard-card-holder dashcard-ani-on">
                <div className="RequestDocNam ssp-grid-dashboard-card" onClick={() => this.handleRedirect(REQUEST_DOCUMENTS)}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>Request a document</h2>
                                <p>See your latest schedule</p>
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>
                <div className="ViewPolicyNam ssp-grid-dashboard-card" onClick={() => this.handleRedirect(PERSONAL_INSURANCE)}>
                    <div className="ssp-grid-dashboard-card-inner">
                        <div className="ssp-grid-dashboard-card-content">
                            <div className="ssp-grid-dashboard-card-content-container">
                                <h2>View your policy</h2>
                                <p>See your latest schedule</p>
                            </div>
                        </div>
                        <div className="ssp-grid-dashboard-card-image"></div>
                        <div className="ssp-grid-dashboard-card-arrow">
                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
      
        let cardView = SAView;
        if (profile.countryId === 157) {
            cardView = NamView;
        }
        return (
            <div className="mt-4 portal-features-container">
                <p className="font-weight-bold">Portal features</p>
                <div className="">
                    {profile.isLinked &&
                        <>
                            <div className="layer-underneath" id="WhatsNewDiv">
                                {cardView}
                            </div>
                        </>
                    }
                    {!profile.isLinked &&
                        <div id="GuestDash" className="layer-underneath">
                            <div className="ssp-grid-dashboard-card-holder dashcard-ani-on">
                            {profile.countryId === 244 &&
                                <div className="WhatsApp ssp-grid-dashboard-card" onClick={() => window.open(WHATSAPP_LIVE_CHAT, "_blank")}>
                                    <div className="ssp-grid-dashboard-card-inner">
                                        <div className="ssp-grid-dashboard-card-content">
                                            <div className="ssp-grid-dashboard-card-content-container">
                                                <h2>WhatsApp live chat</h2>
                                                <p>Try it now</p>
                                            </div>
                                        </div>
                                        <div className="ssp-grid-dashboard-card-image"></div>
                                        <div className="ssp-grid-dashboard-card-arrow">
                                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.props.profile.countryId !== 157 &&
                                <div className="ScratchAndDent ssp-grid-dashboard-card" onClick={this.handleQuote}>
                                    <div className="ssp-grid-dashboard-card-inner">
                                        <div className="ssp-grid-dashboard-card-content">
                                            <div className="ssp-grid-dashboard-card-content-container">
                                                <h2>Scratch and dent</h2>
                                                <p>Get a quote</p>
                                            </div>
                                        </div>
                                        <div className="ssp-grid-dashboard-card-image"></div>
                                        <div className="ssp-grid-dashboard-card-arrow">
                                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.props.profile.countryId !== 157 &&
                                <div className="TyreAndRim ssp-grid-dashboard-card" onClick={this.handleQuote}>
                                    <div className="ssp-grid-dashboard-card-inner">
                                        <div className="ssp-grid-dashboard-card-content">
                                            <div className="ssp-grid-dashboard-card-content-container">
                                                <h2>
                                                    Tyre&nbsp; 
                                                    <span>and rim&nbsp;</span>
                                                    insurance
                                                </h2>
                                                <p>Get a quote</p>
                                            </div>
                                        </div>
                                        <div className="ssp-grid-dashboard-card-image"></div>
                                        <div className="ssp-grid-dashboard-card-arrow">
                                            <div className="ssp-grid-dashboard-card-arrow-actual"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WhatsNew);